import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, setSEO } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import DropListForm from "@/components/DropListForm";
import CountdownTimer from "@/components/CountdownTimer";
import VoidAtmosphere from "@/components/VoidAtmosphere";
import SizingNote from "@/components/SizingNote";

export default function Drop001() {
  const [drop, setDrop] = useState(null);

  useEffect(() => {
    setSEO({
      title: "Drop 001: Controlled Malfunction | FEMBOT NEX",
      description:
        "Drop 001: Controlled Malfunction. Limited-run cyber-femme activewear, sports bras, biker shorts, tanks, and joggers. Preorder window open.",
    });
    api.get("/drops/001").then((r) => setDrop(r.data));
  }, []);

  return (
    <div data-testid="drop-001-page">
      <section className="relative noise scanlines">
        <VoidAtmosphere intensity="hero" />
        <div className="absolute inset-0 hairline-grid opacity-40 pointer-events-none" />
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 pt-16 md:pt-24 pb-12 relative">
          <div className="flex items-center gap-3 mb-6 flex-wrap">
            <img
              src="/brand/emblem.png"
              alt="FEMBOT NEX emblem"
              width={40}
              height={40}
              className="drop-shadow-[0_0_16px_rgba(255,20,147,0.7)]"
              draggable={false}
            />
            <span className="badge badge-live">Pre-Drop // Live</span>
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#c084fc]">
              SS26 · TX_001 · POST HOMINEM
            </span>
          </div>
          <div className="section-label">// DROP 001</div>
          <h1
            data-testid="drop-001-title"
            className="mt-3 font-display text-[44px] sm:text-6xl md:text-[100px] leading-[0.85] tracking-tighter glitch"
          >
            Controlled
            <br />
            <span className="text-[#ff1493]">Malfunction.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-white/90 leading-snug">
            Six pieces of cyber-femme performancewear. Compression-adjacent chaoswear for gym girls, void walkers, and anyone currently buffering through reality.
          </p>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 border border-[#262626] bg-black/60 backdrop-blur-sm">
            {[
              ["Drop Code", drop?.code ? `// ${drop.code}` : "// 001"],
              ["Window", drop ? `${drop.window_days} Days` : "14 Days"],
              ["Production", drop ? `${drop.production_weeks} Wks` : "2-4 Wks"],
              ["Status", drop?.status || "Pre-Drop"],
            ].map(([k, v]) => (
              <div key={k} className="p-4 md:p-6 border-r border-b md:border-b-0 border-[#262626] last:border-r-0">
                <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#6b6b6b]">{k}</div>
                <div className="mt-2 font-display text-base md:text-xl tracking-tight">{v}</div>
              </div>
            ))}
          </div>

          <div className="mt-4 font-mono text-[10px] tracking-[0.2em] uppercase text-[#6b6b6b]">
            // Transmission window: 14 days. Production: 2–4 weeks post-close. All prices USD. US-domestic shipping.
          </div>

          {/* Countdown */}
          <div className="mt-10 max-w-2xl">
            <CountdownTimer joinHref="#drop001-uplink" />
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="mb-12 md:mb-16">
          <SizingNote />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {(drop?.products || []).map((p) => (
            <ProductCard key={p.slug} product={p} />
          ))}
        </div>
      </section>

      <section className="border-t border-[#262626] bg-black/40">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24 grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-6">
            <div className="section-label">// PROTOCOL_0x01</div>
            <h2 className="mt-3 font-display text-3xl md:text-5xl tracking-tight leading-[0.95]">
              Authorize access for first-batch release.
            </h2>
            <p className="mt-6 text-[#a3a3a3] leading-relaxed">
              Drop 001 is pre-drop. Get the launch transmission, restock notifications, and sample-photo drops before they go public.
            </p>
            <div className="mt-6">
              <Link to="/sizing" data-testid="drop-001-sizing-link" className="btn-outline">
                Full Size Guide →
              </Link>
            </div>
          </div>
          <div className="md:col-span-6 border border-[#262626] bg-black p-6 md:p-8" id="drop001-uplink">
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#ff1493] mb-4">
              // UPLINK FORM
            </div>
            <DropListForm source="drop_001_page" testIdPrefix="drop001-list" />
          </div>
        </div>
      </section>
    </div>
  );
}
